import styled, { css, keyframes } from 'styled-components';
import { COLUMN_FOLD_MS } from './builderWorkspace.constants';

const appear = keyframes`
  from { opacity: 0; transform: translateY(-6px); }
  to { opacity: 1; transform: none; }
`;

const nudge = keyframes`
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(2px, -3px); }
`;

export const CoachRoot = styled.div<{ readonly $anchored: boolean }>`
  position: absolute;
  z-index: 30;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  pointer-events: none;
  animation: ${appear} 0.3s ease ${COLUMN_FOLD_MS}ms both;
  ${({ $anchored }) =>
    $anchored
      ? css`
          top: calc(100% + 2px);
          right: 0;
          width: max-content;
        `
      : css`
          top: 8px;
          right: 8px;
          max-width: calc(100% - 16px);
        `}

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

// Its tip sits 12px in from the right edge: the middle of the small chat toggle above it.
export const Arrow = styled.svg`
  flex: none;
  width: 56px;
  height: 44px;
  fill: none;
  stroke: ${({ theme }) => theme.colors.primary};
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  animation: ${nudge} 1.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const CoachRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;
  margin-top: -4px;
  padding: 6px 8px 8px;
  border-radius: 20px;
  background: ${({ theme }) => theme.colors.surfaceContainerHigh};
  box-shadow: ${({ theme }) => theme.elevation?.level3 ?? 'none'};
  pointer-events: auto;
`;

export const Bubble = styled.div`
  max-width: 230px;
`;
